import { render, staticRenderFns } from "./TaskListOrderFaHuoPop.vue?vue&type=template&id=0127a962&"
import script from "./TaskListOrderFaHuoPop.vue?vue&type=script&lang=js&"
export * from "./TaskListOrderFaHuoPop.vue?vue&type=script&lang=js&"
import style0 from "./TaskListOrderFaHuoPop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports